module.exports = __webpack_public_path__ + "img/2_162.7af355be.png";